import { ClientBusiness } from '@app/types';
import axios from 'axios';

const DIVULGADOR_API_BASE_URL = 'https://api.cliqueiachei.com.br/v1';

const api = axios.create({
  baseURL: DIVULGADOR_API_BASE_URL,
});

type LoginPayload = {
  username: string;
  password: string;
};

type UpdatePasswordPayload = {
  accessCode: string;
  newPassword: string;
  businessId: string;
};

type PostImagePayload = {
  photo: any;
  subtitle: string;
};

export const APIDivulgador = {
  async logIn(payload: LoginPayload) {
    const response = await api.post(
      '/clientes/auth',
      {
        username: payload.username,
        Password: payload.password,
      },
      { timeout: 4000 }
    );
    return response;
  },
  async fetchAllBusinessesData(token: string) {
    const response = await api.get<ClientBusiness[]>('/clientes/all', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      timeout: 40000,
    });

    return response;
  },
  async fetchBusinessDetails(businessId: string | number) {
    const response = await api.get(`/clientes/detail/${businessId}`);
    return response;
  },
  async checkAccessCode(businessId: string | number, accessCode: string) {
    const response = await api.get(`/access-code/check?code=${accessCode}&clienteId=${businessId}`);
    return response;
  },
  async updatePassword(payload: UpdatePasswordPayload) {
    const response = await api.put('/clientes/reset-password', {
      CodigoAcesso: payload.accessCode,
      NovaSenha: payload.newPassword,
      ClienteId: payload.businessId,
    });
    return response;
  },
  async postImage(userId: string | number, payload: PostImagePayload, token: string) {
    const formData = new FormData();
    formData.append('foto:1', payload.photo);
    formData.append('legenda:1', payload.subtitle);
    formData.append('sync_google:1', 'false');
    // const validDate = format(date, 'yyyy-MM-dd') + ' ' + format(time, 'HH:mm:ss');
    // formData.append('promocaoValidaAte:1', validDate);

    const { data } = await api.post(`/clientes/${userId}/galeria`, formData, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
    return data;
  },
};
